<template>
  <div class="d-flex flex-column-fluid align-items-start container-xxl">
    <div class="content flex-row-fluid">
      <div class="card mb-5 mb-xl-8">
        <div class="card w-100 rounded-0 border-0" v-if="isLoaded">
          <div id="kt_drawer_chat_messenger_header" class="card-header pe-5">
            <div class="card-title">
              <div class="d-flex justify-content-center flex-column me-3">
                <router-link
                  class="
                    fs-4
                    fw-bolder
                    text-gray-900 text-hover-primary
                    me-1
                    mb-2
                    lh-1
                  "
                  :to="{
                    name: 'psychologist',
                    params: { id: psychologist.id },
                  }"
                  v-slot="{ href, navigate, isActive }"
                >
                  <a
                    :href="href"
                    :class="{ active: isActive }"
                    @click="navigate"
                  >
                    {{ psychologist.name }} {{ psychologist.surname }}
                  </a>
                </router-link>
                <div class="mb-0 lh-1">
                  <span class="fs-7 fw-bold text-muted">{{
                    psychologist.title
                  }}</span>
                </div>
              </div>
            </div>
            <div class="card-toolbar">
              <span class="btn btn-light-primary" @click="backMessages()"
                >Geri dön</span
              >
            </div>
          </div>
          <div id="kt_drawer_chat_messenger_body" class="card-body">
            <div
              data-kt-element="messages"
              data-kt-scroll="true"
              data-kt-scroll-activate="true"
              data-kt-scroll-height="auto"
              data-kt-scroll-dependencies="#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer"
              data-kt-scroll-wrappers="#kt_drawer_chat_messenger_body"
              data-kt-scroll-offset="0px"
              class="scroll-y me-n5 pe-5"
              style="height: 50vh"
            >
              <div
                class="d-flex mb-10"
                v-for="(item, index) in messages"
                :key="`message-${index}`"
                :class="{
                  'justify-content-start': item.isPsychologist,
                  'justify-content-end': !item.isPsychologist,
                }"
              >
                <div
                  class="d-flex flex-column"
                  :class="{
                    'align-items-start': item.isPsychologist,
                    'align-items-end': !item.isPsychologist,
                  }"
                >
                  <div class="d-flex align-items-center mb-2">
                    <div class="symbol symbol-35px symbol-circle">
                      <img
                        alt="2"
                        :src="`https://www.terapikoltugu.app/storage/photos/${item.photo}`"
                      />
                    </div>
                    <div class="ms-3">
                      <a
                        href="#"
                        class="
                          fs-5
                          fw-bolder
                          text-gray-900 text-hover-primary
                          me-1
                        "
                        >{{ item.name }}</a
                      ><span class="text-muted fs-7 mb-1">{{ item.date }}</span>
                    </div>
                  </div>
                  <div
                    data-kt-element="message-text"
                    class="
                      p-5
                      rounded
                      bg-light-info
                      text-dark
                      fw-bold
                      mw-lg-400px
                      text-start
                    "
                  >
                    {{ item.message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="kt_drawer_chat_messenger_footer" class="card-footer pt-4">
            <input
              placeholder="Bir mesaj yaz..."
              class="form-control form-control-flush mb-3"
              type="text"
              v-model="message"
              v-on:keyup.enter="sendMessage()"
              ref="messageInput"
            />
            <div class="d-flex flex-stack">
              <div class="d-flex align-items-center me-2"></div>
              <button
                type="button"
                data-kt-element="send"
                class="btn btn-primary"
                @click="sendMessage()"
              >
                Gönder
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
// import { makeDate } from "@/helpers";
export default {
  data() {
    return {
      isLoaded: false,
      experts: [],
      token: this.$store.getters.getAccessToken,
      params: this.$route.params,
      lastId: "",
      messages: [],
      message: null,
      psychologist: null,
      isSending: false,
      intervalFunc: null,
    };
  },
  async created() {
    await this.getMainContent();
    await this.getUserInfo();
    await this.getMessages();
    this.intervalFunc = setInterval(() => {
      this.getMessages();
    }, 15000);
  },
  beforeDestroy() {
    clearInterval(this.intervalFunc);
  },
  methods: {
    getMainContent: async function () {
      let vm = this;

      let experts = [];

      let response = await API.getMainContent();

      response.data.forEach((item) => {
        item.users.forEach((user) => {
          experts.push(user);
        });
      });

      vm.experts = [
        ...new Map(experts.map((item) => [item["id"], item])).values(),
      ];
    },
    getUserInfo: async function () {
      let vm = this;

      let response = await API.getUserInfo(vm.token);

      vm.user = response.data;
    },
    getMessages: async function () {
      let vm = this;

      if (vm.isSending) return;

      let form = {
        token: vm.token,
        id: vm.params.id,
        lastId: vm.lastId,
      };

      let response = await API.getMessages(form);

      if (response.data.length == 0) return vm.firstMessage();

      let options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };

      let messages = response.data.reverse().map((item) => {
        let obj = {};

        obj.id = item.id;
        obj.message = item.message;
        obj.title = item.title;
        obj.receiver = item.receiver;
        obj.name = `${item.sender.name} ${item.sender.surname}`;
        obj.photo = item.sender.photo;
        obj.isPsychologist = vm.user.id.toString() == item.receiver;
        obj.date = new Date(item.created_at).toLocaleDateString(
          "tr-TR",
          options
        );

        return obj;
      });

      vm.lastId = messages[messages.length - 1].id;

      vm.messages = vm.messages.concat(messages);

      let user = vm.messages.filter((item) => !item.isPsychologist);

      let receiver = user[0].receiver;

      let psychologist = vm.experts.find(
        (item) => item.id.toString() == receiver
      );

      vm.psychologist = {
        name: psychologist
          ? `${psychologist.name} ${psychologist.surname}`
          : "Terapi Koltuğu",
        title: psychologist ? psychologist.title : "Terapi Koltuğu",
        id: psychologist ? psychologist.id : 1,
      };

      vm.isLoaded = true;

      setTimeout(() => {
        document.querySelector('[data-kt-element="messages"]').scroll({
          top: 999999,
          behavior: "smooth",
        });
      }, 150);
    },
    firstMessage: function () {
      let vm = this;

      let psychologist = vm.experts.find((item) => item.id == vm.params.id);

      vm.psychologist = {
        name: psychologist
          ? `${psychologist.name} ${psychologist.surname}`
          : "Terapi Koltuğu",
        title: psychologist ? psychologist.title : "Terapi Koltuğu",
        id: psychologist ? psychologist.id : 1,
      };

      vm.isLoaded = true;
    },
    backMessages: function () {
      this.$router.go(-1);
    },
    sendMessage: async function () {
      let vm = this;

      if (vm.isSending || !vm.message) return;

      vm.isSending = true;

      let form = {
        receiver: vm.psychologist.id,
        message: vm.message,
        token: vm.token,
      };

      vm.message = null;
      await API.sendMessage(form);
      vm.isSending = false;

      vm.getMessages();
    },
  },
};
</script>